import { Badge, IconButton, Tooltip } from "@mui/material";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import {
  assignedLeafletEnquiryLabel,
  assignedLeafletEnquirySearchPath,
  notifyAssignedLeafletEnquirySearch,
  useLeafletEnquirySummary,
} from "@/search/leafletEnquiries";

export default function LeafletEnquiryMenuButton() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const summaryQuery = useLeafletEnquirySummary(!!user, { poll: true });
  const count = summaryQuery.data?.assigned_leaflet_enquiry_count ?? 0;
  const label = assignedLeafletEnquiryLabel(count);

  if (!user || count <= 0) return null;

  return (
    <Tooltip title={label}>
      <IconButton
        size="large"
        color="inherit"
        aria-label={label}
        onClick={() => {
          notifyAssignedLeafletEnquirySearch(user.id);
          navigate(assignedLeafletEnquirySearchPath(user.id));
        }}
      >
        <Badge badgeContent={count} color="error" max={99}>
          <RequestQuoteOutlinedIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
